/* ============================================================================
   Artline NON-PRESS PAINT MARKER — page behaviours (VANILLA JS)
   #18: rewritten with zero jQuery / no Slick. Same behaviour as before, each
   block inert until its section exists. Load order (deferred): main -> init (THIS).
     1. .photo scroll reveal (feature cards)
     2. vanilla FADE hero carousel (#slider) — crossfade, 5s autoplay, dots,
        pauseOnHover/pauseOnFocus, a visible play/pause control, reduced-motion gate
     3. .js-fade* scroll fade-in (incl. body fade)
     4. cost-simulation calculator
   Self-guards against double-init.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__artlineNpBehaviors) { return; }
  window.__artlineNpBehaviors = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function viewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight;
  }

  /* ---- 1. feature-card photo reveal (adds .move on scroll) ---- */
  ready(function () {
    var photos = toArray(document.querySelectorAll('.photo'));
    if (!photos.length) { return; }

    function checkInView() {
      var wh = viewportHeight();
      // jQuery: scroll >= imgTop - windowHeight  <=>  rect.top <= windowHeight
      photos.forEach(function (el) {
        if (el.getBoundingClientRect().top <= wh) { el.classList.add('move'); }
      });
    }

    window.addEventListener('scroll', checkInView, { passive: true });
    window.addEventListener('resize', checkInView);
    window.addEventListener('load', checkInView);
    checkInView();
  });

  /* ---- 2. vanilla fade hero carousel (replaces the slick #slider slider) ----
     Behaviour preserved from the slick config: autoplay 5000ms, 2000ms crossfade,
     dots, no arrows, pauseOnHover + pauseOnFocus, a visible play/pause control,
     and autoplay gated off under prefers-reduced-motion (first slide shown). */
  ready(function () {
    var slider = document.getElementById('slider');
    if (!slider || slider.dataset.npReady) { return; }
    var track = slider.querySelector('.slick-track');
    var slides = track ? toArray(track.querySelectorAll('.slick-slide')) : [];
    if (!slides.length) { return; }
    slider.dataset.npReady = '1';

    var current = 0;
    var autoplayTimer = null;
    var paused = false;       // manual (play/pause button) — mirrors slick 'paused'
    var interrupted = false;  // pauseOnHover                — mirrors slick 'interrupted'
    var focussed = false;     // pauseOnFocus                — mirrors slick 'focussed'

    var dots = [];

    function updateDots() {
      dots.forEach(function (d, i) {
        var active = i === current;
        d.li.classList.toggle('slick-active', active);
        d.btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function show(idx) {
      idx = (idx + slides.length) % slides.length;
      if (idx === current) { return; }
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = idx;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      updateDots();
    }

    function next() { show(current + 1); }

    /* Single recurring timer that only advances when nothing is holding it back
       (matches slick's autoPlayIterator: !paused && !interrupted && !focussed). */
    function autoPlayIterator() {
      if (!paused && !interrupted && !focussed) { next(); }
    }
    function clearAutoPlay() {
      if (autoplayTimer) { window.clearInterval(autoplayTimer); autoplayTimer = null; }
    }
    function startAutoPlay() {
      clearAutoPlay();
      if (slides.length > 1) { autoplayTimer = window.setInterval(autoPlayIterator, 5000); }
    }

    // Build the dots (slick dots:true — rendered whether or not autoplay runs).
    var dotsUl = document.createElement('ul');
    dotsUl.className = 'slick-dots';
    slides.forEach(function (slide, i) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.textContent = String(i + 1);
      btn.addEventListener('click', function () {
        show(i);
        if (autoplayTimer) { startAutoPlay(); }   // reset the 5s clock on interaction
      });
      li.appendChild(btn);
      dotsUl.appendChild(li);
      dots.push({ li: li, btn: btn });
    });
    slider.appendChild(dotsUl);

    // Initial state: first slide active, mark the rest hidden.
    slides.forEach(function (s, i) {
      s.classList.remove('is-active');
      s.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });
    slides[0].classList.add('is-active');
    current = 0;
    slider.classList.add('is-initialized');
    updateDots();

    if (!reduceMotion) {
      // pauseOnHover
      slider.addEventListener('mouseenter', function () { interrupted = true; });
      slider.addEventListener('mouseleave', function () { interrupted = false; });
      // pauseOnFocus (dots / play-pause live inside #slider)
      slider.addEventListener('focusin', function () { focussed = true; });
      slider.addEventListener('focusout', function (e) {
        if (!slider.contains(e.relatedTarget)) { focussed = false; }
      });

      // Visible play/pause control (only meaningful while autoplay runs).
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'slider_playpause';
      toggle.setAttribute('aria-label', 'Pause slideshow');
      toggle.textContent = 'Pause';
      toggle.addEventListener('click', function () {
        paused = !paused;
        if (paused) {
          toggle.textContent = 'Play';
          toggle.setAttribute('aria-label', 'Play slideshow');
        } else {
          toggle.textContent = 'Pause';
          toggle.setAttribute('aria-label', 'Pause slideshow');
        }
      });
      slider.appendChild(toggle);

      startAutoPlay();
    }
  });

  /* ---- 3. .js-fade* scroll fade-in (body + sections) ---- */
  ready(function () {
    var selector = '.js-fade, .js-fadeBottom, .js-fadeBottom1, .js-fadeBottom2, .js-fadeBottom3, .js-fadeBottom4, .js-fadeBottom5, .js-fadeBottom6';

    function checkElementVisibility() {
      var wh = viewportHeight();
      // jQuery: scroll + windowHeight > pos  <=>  rect.top < windowHeight
      toArray(document.querySelectorAll(selector)).forEach(function (el) {
        if (!el.classList.contains('animated') && el.getBoundingClientRect().top < wh) {
          el.classList.add('animated');
        }
      });
    }

    checkElementVisibility();
    window.addEventListener('scroll', checkElementVisibility, { passive: true });
  });

  /* ---- 4. cost-simulation calculator (verbatim logic; only runs if present) ---- */
  ready(function () {
    if (!document.getElementById('a-marker')) { return; }

    function formatInputValue(value) {
      var numericValue = value.replace(/[０-９]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 65248); })
        .replace(/[^0-9.]/g, '');
      if (!/^\d*\.?\d{0,2}$/.test(numericValue)) { return '$0.00'; }
      var floatValue = parseFloat(numericValue);
      return isNaN(floatValue) || floatValue < 0 ? '$0.00' : '$' + floatValue.toFixed(2);
    }

    function getNumericValue(formattedValue) {
      return parseFloat(formattedValue.replace(/[^0-9.]/g, '')) || 0;
    }

    function calculateResults() {
      var aMarkerPrice = getNumericValue(document.getElementById('a-marker').value);
      var aRefillInkPrice = getNumericValue(document.getElementById('a-refill-ink').value);
      var aRefillNibPrice = getNumericValue(document.getElementById('a-refill-nib').value);
      var bMarkerPrice = getNumericValue(document.getElementById('b-marker').value);

      var aMarkerQty = 1;
      var aRefillInkQty = 1;
      var aRefillNibQty = Math.ceil(aRefillInkQty * 10);
      var bMarkerQty = (aRefillInkQty * 10 + aMarkerQty) * 380 / 250;

      var totalA = (aMarkerPrice * aMarkerQty) + (aRefillInkPrice * aRefillInkQty) + (aRefillNibPrice * aRefillNibQty);
      var totalB = bMarkerPrice * bMarkerQty;

      var costCut = 0;
      if (totalB > 0) { costCut = Math.floor(((totalB - totalA) / totalB) * 100); }

      document.getElementById('total-a').innerHTML = '<span class="label pc_on_flex480">Total Cost</span><span class="label sp_on_flex480">Total<br>Cost</span> <span class="amount">$' + totalA.toFixed(2) + '</span>';
      document.getElementById('total-b').innerHTML = '<span class="label pc_on_flex480">Total Cost</span><span class="label sp_on_flex480">Total<br>Cost</span> <span class="amount">$' + totalB.toFixed(2) + '</span>';
      document.getElementById('cost-cut').innerHTML = '<div class="img_cut_costs"><img class="pc_on_block890" src="' + (window.ANP_CUTCOSTS || '') + '" alt=""/><img class="sp_on_block890" src="' + (window.ANP_CUTCOSTS2 || '') + '" alt=""/></div><span class="cut_amount"><span class="cut_value">' + costCut + '</span><span class="cut_symbol">%</span></span>';
    }

    function validateInput(input) {
      var errorElement = document.getElementById('error-' + input.id);
      if (!errorElement) { return; }
      var isValid = /^\$?\d*\.?\d{0,2}$/.test(input.value.replace(/[０-９]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 65248); }));
      errorElement.style.display = isValid ? 'none' : 'block';
    }

    var calcRoot = document.querySelector('.cost_simulation_bg') || document;
    toArray(calcRoot.querySelectorAll('input[type="text"]')).forEach(function (input) {
      input.addEventListener('blur', function () {
        input.value = formatInputValue(input.value);
        validateInput(input);
        calculateResults();
      });
      input.addEventListener('focus', function () {
        input.value = input.value.replace(/\$/g, '');
        input.select();
      });
      input.addEventListener('input', function () {
        var originalValue = input.value;
        var formattedValue = originalValue.replace(/[０-９]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 65248); });
        if (formattedValue !== originalValue) { input.value = formattedValue; }
        validateInput(input);
      });
      input.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') { input.blur(); }
      });
    });

    calculateResults();
  });

})();
